<template>
  <div class="custom-treeselect">
    <treeselect
      v-model="inputVal"
      :multiple="true"
      :options="items"
      value-consists-of="LEAF_PRIORITY"
      :disabled="disabled"
      :placeholder="
        localStorage.translations.pages.sales_project['planned_resources-time_period-inputs'][
          'ne-vybrano'
        ]
      "
      :maxHeight="130"
      :rules="rules"
    />
  </div>
</template>

<script>
import Treeselect from '@riophae/vue-treeselect'
import '@riophae/vue-treeselect/dist/vue-treeselect.css'

export default {
  name: 'TreeselectCustom',
  components: { Treeselect },
  // props: ['value', 'items', 'disabled'],
  props: {
    value: Array,
    items: Array,
    disabled: Boolean,
    rules: {
      type: Array,
      required: false,
    },
  },
  data() {
    return {}
  },
  computed: {
    inputVal: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      },
    },
  },
}
</script>

<style lang="scss" scoped></style>
